// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmDeleteModal_customerTitle__ChFl8","customerLabel":"ConfirmDeleteModal_customerLabel__p5McU","customerBtn":"ConfirmDeleteModal_customerBtn__v5dEr"};